export default (computedStyles, el = null) => {
    const { fontSize, fontFamily } = computedStyles;
    let { lineHeight } = computedStyles;
    const parsedFontSize = parseFloat(fontSize);
    const impIndex = lineHeight.indexOf(" !important");
    if (impIndex > 0) {
        lineHeight = lineHeight.slice(0, impIndex);
    }
    if (lineHeight === 'normal' || lineHeight === 'inherit') {
        if (el) {
            const temp = document.createElement('div');
            temp.setAttribute("style", `margin: 0; padding: 0; font-family: ${fontFamily || "inherit"}; font-size: ${fontSize || "inherit"};`);
            temp.innerHTML = "(";
            el.parentNode.appendChild(temp);
            const ret = temp.clientHeight / 2;
            el.parentNode.removeChild(temp);
            return ret;
        }
        return parsedFontSize;
    }
    const parsedLineHeight = parseFloat(lineHeight);
    if (String(parseFloat(lineHeight)) === lineHeight) {
        return parsedLineHeight * parsedFontSize;
    }
    if (lineHeight.indexOf('%') !== -1) {
        return parsedLineHeight * parsedFontSize / 100;
    }
    return parsedLineHeight;
}